export const salesLocationOptions = [
  {
    key: '16000- Cimtec Distribution',
    value: '16000- Cimtec Distribution',
  },
  {
    key: '16010- Qualitrol',
    value: '16010- Qualitrol',
  },
];
